import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { useState } from "react";
import useDebounce from "../../lib/useDebounce";
import { IDataPesquisarTransp } from "../../types/api/estoque/pesquisar-transportadores";
import { formatarCPFCNPJ } from "../../helpers/masks";

export default function SelectTransportadora({
    value,
    onChange
}: SelectSimpleApiQueryProps) {

    const [keyword, setKeyword] = useState("")

    const dbKeyword = useDebounce(keyword)

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-transportadores", dbKeyword],
        queryFn: () => axiosClient.get("estoque/pesquisar-transportadores", {
            params: {
                limit: 30,
                pesquisar: dbKeyword
            }
        })
    });
    const listData: IDataPesquisarTransp[] = data?.data.data || []
    //

    return (
        <Autocomplete
            disabled={isLoading && keyword === ""}
            id="combo-box-demo"
            value={value}
            inputValue={keyword}
            loading={isLoading}
            loadingText="Carregando..."
            options={listData.map((i) => ({ doc: String(i.cpf_cnpj), label: `${i.transportador_id} - ${i.nome_transportador}`, id: String(i.transportador_id) }))}
            onChange={(_: any, newValue: TObjValue | null) => {
                onChange(newValue);
            }}
            noOptionsText={isLoading ? "Carregando..." : "Sem resultados"}
            onInputChange={(_, newInputValue) => {
                setKeyword(newInputValue);
            }}
            renderInput={(params) => <TextField {...params} label="Transportador" fullWidth />}
            renderOption={(props, option) => (
                <li {...props}>
                    <Box display="flex" flexDirection="column">
                        <Typography variant="subtitle2">{option.label}</Typography>
                        <Typography variant="caption" color="gray">{formatarCPFCNPJ(option.doc)}</Typography>
                    </Box>
                </li>
            )}
        />
    )
}

interface SelectSimpleApiQueryProps {
    value: TObjValue | null
    onChange: (arg: TObjValue | null) => void
}

type TObjValue = { label: string, id: string, doc: string }